import * as React from 'react';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useVto } from '../../context/VtoProvider.js';

const TryOnButton = ({ variant ='foreground' , onClick , className  })=>{
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    const { isVtoFeatureEnabled , setVtoActive  } = useVto();
    const buttonSize = isPhone ? 'small' : 'medium';
    const color = variant === 'solid' ? 'primary' : undefined;
    const startVTO = ()=>{
        setVtoActive(true);
        onClick && onClick();
    };
    if (!isVtoFeatureEnabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('vto.callToAction'),
        "data-t": "vto-try-on-button",
        variant: variant,
        icon: "try-on",
        color: color,
        size: buttonSize,
        onClick: startVTO,
        className: className
    });
};

export { TryOnButton };
//# sourceMappingURL=TryOnButton.js.map
